import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { Icon } from '~/components';
import { Button } from '~/components/Button';
import { Breadcrumbs } from '~/modules/navigation/components/Breadcrumbs';
import { ContentBox } from '~/modules/settings/components/ContentBox';
import { CTABlock } from '~/modules/settings/components/CTABlock';
import { Header } from '~/modules/settings/components/Header';
import { HeaderSmall } from '~/modules/settings/components/HeaderSmall';
import { SETTINGS_ROUTES } from '~/modules/settings/config/routes';

import type { UserFormSchema } from '../../components/UserForm';
import { UserForm } from '../../components/UserForm';

const FORM_ID = 'createUserForm';

export function EditUserPage() {
  const { t } = useTranslation('settings');
  const { uuid } = useParams();

  console.log(uuid); // TODO: replace with actual user fetching
  const user = {} as UserFormSchema;

  const onSubmit = (data: UserFormSchema) => {
    console.log(data);
  };

  return (
    <article className="relative h-full">
      <Header
        breadcrumbs={
          <Breadcrumbs.Root>
            <Breadcrumbs.Item to={SETTINGS_ROUTES.ROOT}>
              <Icon type="gear" size="sm" variant="regular" className="mr-sm" />
              {t('title')}
            </Breadcrumbs.Item>
            <Breadcrumbs.Item to={SETTINGS_ROUTES.USER_LIST}>
              {t('users')}
            </Breadcrumbs.Item>
            <Breadcrumbs.Item>{t('user.editUserTitle')}</Breadcrumbs.Item>
          </Breadcrumbs.Root>
        }
      >
        <h1 className="pb-xl text-display-sm font-bold">
          {t('user.editUserTitle')}
        </h1>
      </Header>
      <ContentBox>
        <HeaderSmall>{t('user.detailsTitle')}</HeaderSmall>
        <UserForm onSubmit={onSubmit} id={FORM_ID} values={user} />
      </ContentBox>
      <CTABlock>
        <Button asChild variant="secondary" size="large">
          <Link to={SETTINGS_ROUTES.USER_LIST}>{t('cancelButton')}</Link>
        </Button>
        <Button variant="primary" type="submit" size="large" form={FORM_ID}>
          {t('user.addUserButton')}
        </Button>
      </CTABlock>
    </article>
  );
}

EditUserPage.displayName = 'EditUserPage';
